import moment from 'moment';

export const LAST_YEAR_WEEKS_WEDNESDAY = [...Array(52).keys()].map(
	(howManySubstract) => {
		const element = {};

		element.value = moment()
			.day(3)
			.add(1, 'week')
			.subtract(howManySubstract, 'weeks');

		element.label = element.value.format('YYYY-MM-DD');

		return element;
	},
);
